import {H2, H3, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col, Grid} from '@/grid';
import {withBgPurple50, withNeutral800} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';

const imgPath = '/static/images/features/ai-section/';

const Purple50Section = withBgPurple50(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3UpperNeutral800 = withNeutral800(
  withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)))
);
const DivMargined = withMarginBottomDoubleXlToXl('div');

const AiSection = () => {
  const t = useTranslations('features.aiSection');

  const CreatingContentFeaturesArray = t.raw('creatingContent.features');
  const SourcingAndMatchingFeaturesArray = t.raw('sourcingMatching.features');
  const AutomatingTasksFeaturesArray = t.raw('automatingTasks.features');

  return (
    <Purple50Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="ai-section"
                imageTypeFallback="jpg"
                alt={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('creatingContent.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {CreatingContentFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#E5D3F7">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('sourcingMatching.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {SourcingAndMatchingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#E5D3F7">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3UpperNeutral800 className="heading-4">
              {t('automatingTasks.title')}
            </H3UpperNeutral800>
            <GridLayout Col={3} lgCol={2} autoRows>
              {AutomatingTasksFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="#E5D3F7">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Purple50Section>
  );
};

export default AiSection;
